import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

export const fetchUsers = async () => {
  const res = await axios.get(`${API_URL}/users`, header());
  return res.data;
};

export const fetchUser = async (id) => {
  const res = await axios.get(`${API_URL}/users/id/${id}`, header());
  return res.data;
};

export const createUser = async (payload) => {
  const res = await axios.post(`${API_URL}/users`, payload, header());
  return res.data;
};

export const updateUser = async (id, payload) => {
  const res = await axios.put(`${API_URL}/users/${id}`, payload, header());
  return res.data;
};

export default {
  fetchUsers,
  fetchUser,
  createUser,
  updateUser,
};
